import { useDispatch, useSelector } from "react-redux";
import getSuccessMessage from "./getSuccessMessage";
import DismissibleSuccessBanner from "../../../presentational/customerItems/DismissibleSuccessBanner";
import { dismissSuccessBanner } from "../../../../state/modules/savedItems/actions";

const ConnectedDismissibleSuccessBanner = props => {
  const successMessage = useSelector(getSuccessMessage);
  const dispatch = useDispatch();

  return (
    <DismissibleSuccessBanner
      onDismiss={() => dispatch(dismissSuccessBanner())}
      {...{ ...props, successMessage }}
    />
  );
};

export default ConnectedDismissibleSuccessBanner;
